// eslint-disable-next-line no-unused-vars
import React from 'react';
import { mixed, string, object } from 'yup';

import GROUP_TYPES, { INDUSTRY_WITH_TYPES } from 'data/groupTypes';
import { dobAtLeast16 } from './shared/dob';
import { passwordSchema } from './shared/password';

const schema = object().shape({
  firstName: string().required('Please enter your first name'),
  lastName: string().required('Please enter your last name'),
  email: string()
    .email()
    .required('Please enter your email'),
  password: passwordSchema,
  groupName: string().required('Please enter a group name'),
  groupDesc: string().required('Please enter the group description'),
  groupType: mixed()
    .oneOf(GROUP_TYPES.map(t => t.value))
    .required('Please choose a group type'),
  groupIndustry: string()
    .nullable()
    .when('groupType', {
      is: groupType => INDUSTRY_WITH_TYPES.includes(groupType),
      then: string().required('The group type you have selected requires an industry type'),
    }),
  birthdate: dobAtLeast16,
});

export default schema;
